import React from 'react';
import NextButton from './NextButton';

const SaksClueTwo: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p>
        Pick out one nice makeup item for yourself! Something fancy that will
        bring you joy when you get to use it 😊 Might I suggest a fancy
        lipstick?
      </p>
      <img style={{ width: '100%' }} src='lipstick.jpg' />
      <p>Just a suggestion though please pick out anything that you want!</p>
      <NextButton
        prompt='Enter the city I was in when we matched on Hinge for your next clue'
        acceptedClues={['cleveland']}
      />
    </div>
  );
};

export default SaksClueTwo;
